export default __webpack_public_path__ + "static/media/Leggings of Vindictive Malice.e095da36.jpg";